// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import SystemActions from './../../actions/SystemActions';
interface ObjectAssignmentProps {
    leftHeader: any;
    rightHeader: any;
    availableObjects: any[];
    assignedObjects: any[];
    inheritedObjectAttribute?: string;
    onClick?: any;
    onValueChanged?: any;
    validateAssign?: any;
    validateRemove?: any;
}

interface ObjectAssignmentState {
    availableObjects: any[],
    assignedObjects: any[],
    selectedAvailableObjects: any[],
    selectedAssignedObjects: any[]
}

class ObjectAssignment extends React.Component<ObjectAssignmentProps, ObjectAssignmentState> {
    constructor(props: ObjectAssignmentProps, context: any) {
        super(props, context);

        this.state = {
            availableObjects: [],
            selectedAvailableObjects: [],
            selectedAssignedObjects: [],
            assignedObjects: this.props.assignedObjects.map((object) => {
                return object;
            })
        };
    }
    private _assign = () => {
        var selectedObjects = this.state.selectedAvailableObjects;
        if (selectedObjects.length > 0) {
            for (var i = 0; i < selectedObjects.length; i++) {
                var selectedObject = selectedObjects[i];
                this.state.assignedObjects.push(selectedObject);

                var index = this.state.availableObjects.indexOf(selectedObject);
                this.state.availableObjects.splice(index, 1);
            };
            (this.state as any).selectedAvailableObjects = [];
            this.setState(this.state);
            this.props.onValueChanged(this.state.assignedObjects);
        }
    }

    private _assignAll = () => {
        (this.state as any).availableObjects = this.props.availableObjects;
        for (var i = 0; i < this.state.availableObjects.length; i++) {
            var availableObject = this.state.availableObjects[i];
            this.state.assignedObjects.push(availableObject);
        };
        (this.state as any).availableObjects = [];
        (this.state as any).selectedAvailableObjects = [];
        this.setState(this.state);
        this.props.onValueChanged(this.state.assignedObjects);
    }

    private _remove = () => {
        var selectedObjects = this.state.selectedAssignedObjects;
        if (this.props.validateRemove(selectedObjects)) {
            for (var i = 0; i < selectedObjects.length; i++) {
                var selectedObject = selectedObjects[i];
                this.state.availableObjects.push(selectedObject);

                var index = this.state.assignedObjects.indexOf(selectedObject);
                this.state.assignedObjects.splice(index, 1);
            };
            (this.state as any).selectedAssignedObjects = [];
            this.setState(this.state);
            this.props.onValueChanged(this.state.assignedObjects);
        }
    }

    private _removeAll = () => {
        if (this.props.validateRemove(this.state.assignedObjects)) {
            for (var i = 0; i < this.state.assignedObjects.length; i++) {
                var object = this.state.assignedObjects[i];
                this.state.availableObjects.push(object);
            };
            (this.state as any).assignedObjects = [];
            (this.state as any).selectedAssignedObjects = []
            this.setState(this.state);
            this.props.onValueChanged(this.state.assignedObjects);
        }
    }

    private _availableObjects = (object: any[]) => {
        var selectedAvailableObjects = this.state.selectedAvailableObjects;

        if (selectedAvailableObjects.indexOf(object) === -1) {
            selectedAvailableObjects.push(object)
        } else {
            var index = selectedAvailableObjects.indexOf(object);
            selectedAvailableObjects.splice(index, 1);
        };
    }

    private _assignedObjects = (object: any[]) => {
        var selectedAssignedObjects = this.state.selectedAssignedObjects;

        if (selectedAssignedObjects.indexOf(object) === -1) {
            selectedAssignedObjects.push(object);
        } else {
            var index = selectedAssignedObjects.indexOf(object);
            selectedAssignedObjects.splice(index, 1);
        };
    }
    
    render() {
        var availableObjects = this.props.availableObjects.map((object) => {
            return <ObjectItem object={object} key={object.ID} onClick={this._availableObjects}/>
        });

        var assignedObjects = this.props.assignedObjects.map((object) => {
            return <ObjectItem object={object} key={object.ID} onClick={this._assignedObjects} readOnlyAttribute={this.props.inheritedObjectAttribute}/>
        });

        return (
            <div className="object-assignment-container">
                <div className="object-list">
                    <header>{this.props.leftHeader}</header>
                    <ul className="object-list-inner">
                        {availableObjects}
                    </ul>
                </div>
                <div className="assign-object-commands">
                    <ul>
                        <li className="assign-object-btn"><span className="glyphicon glyphicon-triangle-right" onClick={this._assign}></span></li>
                        <li className="assign-object-btn"><span className="glyphicon glyphicon-forward" onClick={this._assignAll}></span></li>
                        <li className="assign-object-btn"><span className="glyphicon glyphicon-triangle-left" onClick={this._remove}></span></li>
                        <li className="assign-object-btn"><span className="glyphicon glyphicon-backward" onClick={this._removeAll}></span></li>
                    </ul>
                </div>
                <div className="object-list">
                    <header>{this.props.rightHeader}</header>
                    <ul className="object-list-inner">
                        {assignedObjects}
                    </ul>
                </div>
            </div>
        )
    }
}

interface ObjectItemProps extends React.PropsWithChildren<{}> {
    object: any;
    readOnlyAttribute?: string;
    onClick?: any;
}

interface ObjectItemState {
    selected: boolean;
}

class ObjectItem extends React.Component<ObjectItemProps, ObjectItemState> {
    constructor(props: ObjectItemProps, context: any) {
        super(props, context);


        this.state = { selected: false };
    }

    private _toggleSelected = () => {
        this.setState({
            selected: !this.state.selected
        });
    }

    private _onClick = (object: any) => {
        this.props.onClick(object);
        this._toggleSelected();
    }

    render() {
        var object = this.props.object;

        var isReadOnly = this.props.object[this.props.readOnlyAttribute] ? 'inherited-object' : '';
        var isSelected = this.state.selected ? "selected" : "";
        return (
            <li className={`object-list-item ${isReadOnly} ${isSelected}`} onClick={() => this._onClick(object) }>{object.Name}</li>
        )
    }
}

export default ObjectAssignment;